import { Flex, Stack, Heading, Text, useColorModeValue, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import notFound from '../../assets/404.png';

const NotFound = (props) => {

    const { t } = useTranslation();

    return (
        <Flex
                height="100vh"
                bg={useColorModeValue('white', 'gray.700')}
                rounded={'xl'}
                direction="column"
                p={10}
                spacing={8}
                justifyContent="center"
                align={'center'}>

                <Image src={notFound} alt="404" width="100%" maxWidth="400px"/>

                <Stack align={'center'} spacing={2}>
                    <Heading
                        textTransform={'uppercase'}
                        fontSize={'3xl'}
                        color={useColorModeValue('gray.800', 'gray.200')}>
                        { t("whoops") }
                    </Heading>
                    <Text align={'center'} fontSize={'lg'} color={'gray.500'}>
                        { t("notFoundMsg") }
                    </Text>
                </Stack>
            </Flex>
    );
}

export default NotFound;